import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientSettingImplEncoder } from "../../encoder/ClientSettingImplEncoder";

import * as CubiqTS from "../../index";
import { ClientSetting } from "../ClientSetting";

export class ClientSettingImpl extends ConcreteEncodable implements ClientSetting {
  public static enType: string = "com.bcdfx.model.ClientSettingImpl";

  /*FID=1*/
  public clientCd: string;
  /*FID=2*/
  public comment1: string;
  /*FID=3*/
  public comment2: string;
  /*FID=4*/
  public contactNameTxt: string;
  /*FID=5*/
  public deskTxt: string;
  /*FID=6*/
  public emailTxt: string;
  /*FID=7*/
  public id: CubiqTS.Long | null = null;
  /*FID=8*/
  public mobileTxt: string;
  /*FID=9*/
  public notifyEntry: CubiqTS.NotificationMethod;
  /*FID=10*/
  public notifyExpiry: CubiqTS.NotificationMethod;
  /*FID=11*/
  public notifyFill: CubiqTS.NotificationMethod;
  /*FID=12*/
  public smsTxt: string;
  /*FID=13*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=14*/
  public isDefaultFg: boolean;
  /*FID=15*/
  public isDeletedFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientSettingImplEncoder.Instance;
    this.setEncodableType(ClientSettingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ClientSettingImpl[" +
      "clientCd=" +
      this.clientCd +
      "comment1=" +
      this.comment1 +
      "comment2=" +
      this.comment2 +
      "contactNameTxt=" +
      this.contactNameTxt +
      "deskTxt=" +
      this.deskTxt +
      "emailTxt=" +
      this.emailTxt +
      "id=" +
      this.id +
      "mobileTxt=" +
      this.mobileTxt +
      "notifyEntry=" +
      this.notifyEntry +
      "notifyExpiry=" +
      this.notifyExpiry +
      "notifyFill=" +
      this.notifyFill +
      "smsTxt=" +
      this.smsTxt +
      "stamp=" +
      this.stamp +
      "isDefaultFg=" +
      this.isDefaultFg +
      "isDeletedFg=" +
      this.isDeletedFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
